import { z } from "zod";

export const evaluationSchema = z.object({
  id: z.number(),
  content: z.string(),
  weight: z.number(),
});

export const EvaluationCreateSchema = evaluationSchema.omit({
  id: true,
});
